"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AlertsEntity_1 = __importDefault(require("./Entity/AlertsEntity"));
var AlertsApi = /** @class */ (function () {
    function AlertsApi(session) {
        this.alertsEntity = new AlertsEntity_1.default(session);
    }
    AlertsApi.prototype.attachSubscriptions = function () {
        this.alertsEntity.attachSubscriptions();
    };
    AlertsApi.prototype.subscribeOnCreate = function (cb) {
        return this.alertsEntity.registerOnCreate(cb);
    };
    AlertsApi.prototype.subscribeOnDelete = function (cb) {
        return this.alertsEntity.registerOnDelete(cb);
    };
    AlertsApi.prototype.subscribeOnUpdateOwnership = function (cb) {
        return this.alertsEntity.registerOnUpdateOwnership(cb);
    };
    AlertsApi.prototype.getAlertsKeySetPagination = function (queryParams) {
        return this.alertsEntity.getAlertsKeySetPagination(queryParams);
    };
    AlertsApi.prototype.dismiss = function (uuid) {
        return this.alertsEntity.dismiss(uuid);
    };
    AlertsApi.prototype.batchDismiss = function (uuids) {
        return this.alertsEntity.batchDismiss(uuids);
    };
    AlertsApi.prototype.updateOwnership = function (params) {
        return this.alertsEntity.updateOwnership(params);
    };
    return AlertsApi;
}());
exports.default = AlertsApi;
//# sourceMappingURL=AlertsApi.js.map